import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const ContentCtx = createContext(null);

const DEFAULT_CONTENT = {
  home: {
    hero_eyebrow: "New · Spring Atelier 2026",
    hero_title_lead: "Short kurtis,",
    hero_title_accent: "softly",
    hero_title_tail: "crafted.",
    hero_paragraph: "A quiet rebellion of blush tones, heritage weaves, and modern silhouettes. Every Flownté piece is hand-made for women who move through the world with grace.",
    hero_cta_primary: "Shop the collection",
    hero_cta_secondary: "Our story",
    hero_image_main: "",
    hero_image_secondary: "",
    hero_image_tertiary: "",
    hero_badge_title: "Elegance in Motion",
    hero_badge_sub: "Spring 2026 · 48 new pieces",
    stat_1_value: "12k+",
    stat_1_label: "Happy women",
    stat_2_value: "4.9 ★",
    stat_2_label: "Avg. rating",
    stat_3_value: "200+",
    stat_3_label: "Artisans",
  },
  about: { hero_eyebrow: "our story", hero_title_lead: "Quietly made,", hero_title_accent: "deeply loved.", hero_paragraph: "", story_eyebrow: "since 2021", story_title: "", story_paragraphs: [], image_left: "", image_right: "", values: [] },
  contact: { email: "hello@flownte.in", email_sub: "", phone: "+91 60025 81586", phone_sub: "", address: "Guwahati, Assam", address_sub: "" },
  footer: { tagline: "", contact_block: "", copyright: "© {year} Flownté Clothing.", sub_copyright: "" },
  social: { instagram: "https://instagram.com", facebook: "https://facebook.com", email_url: "mailto:hello@flownte.in" },
  seo: { site_title: "Flownté Clothing — Elegance in Motion", site_description: "", og_image: "", keywords: "" },
  fabric_care: {
    enabled: true,
    title: "Fabric & Care",
    fabric_heading: "Fabric",
    fabric_body: "",
    care_heading: "Care",
    care_bullets: [],
  },
};

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/storefront/content")
      .then((r) => setContent({ ...DEFAULT_CONTENT, ...r.data }))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return <ContentCtx.Provider value={{ content, loaded }}>{children}</ContentCtx.Provider>;
}

export function useContent() {
  return useContext(ContentCtx) || { content: DEFAULT_CONTENT, loaded: false };
}
